/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content1/view.blocks to change it.
import Content from './Content/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentHover from 'DesignSystem/Popover/PopoverContentHover/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import Trigger from './Trigger/index'



/** @type {import('Simple/types.js').View} */
export default function Content1({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/TopBar/Order/Content"
  
}) {
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
 showOnClick={false}
 showOnHover={true}
 offsetMainAxis={8}
 offsetCrossAxis={8}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<Trigger
{...childProps}
  viewPath={`${viewPath}/Trigger`}
/>
)}
</PopoverTrigger>
<PopoverContentHover
{...childProps}
  viewPath={`${viewPath}/PopoverContentHover`}
>
{childProps => (
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
)}
</PopoverContentHover>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}